// The tile set is not part of this bundle. It is about 38MB of tiles, sprites
// and data built by the pixel map project, and it is served from its own
// address: a Bunny pull zone in production (ADR 0008) and the map project
// itself in development. Its data files set window globals, so they are loaded
// with script tags from that address, which the Content Security Policy allows
// because the address is our own origin or one it names.
//
// Each file loads once per page. A Turbo visit keeps `window`, so a map drawn
// on the second visit finds the globals already set and starts at once.
const FILES = [
  { path: "tiles/manifest.js", global: "MAP_MANIFEST", required: true },
  { path: "markers/atlas.js", global: "MARKER_ATLAS", required: true },
  { path: "data/cities.js", global: "MAP_CITIES", required: false },
  // Draws the deepest levels in the browser. It finds its own chunks from the
  // address it was loaded from, so it must be loaded from the tile set too.
  { path: "tiles/deep-renderer.js", global: "DeepRenderer", required: false }
]

const loading = new Map()

function loadScript(src) {
  if (loading.has(src)) return loading.get(src)

  const promise = new Promise((resolve) => {
    const script = document.createElement("script")
    script.src = src
    script.async = false
    script.onload = () => resolve(true)
    script.onerror = () => resolve(false)
    document.head.appendChild(script)
  })
  loading.set(src, promise)
  return promise
}

// Resolves with the globals, or with `null` when a file the map cannot draw
// without did not arrive. Never rejects: a missing map is a sentence on the
// page, not an exception.
export async function loadTileSet(base) {
  // Asked for together and run in order: `async = false` keeps the order, so
  // waiting for each before asking for the next only added a round trip per
  // file (cities.js alone is 250KB).
  const missing = FILES.filter((file) => !window[file.global])
  const arrived = await Promise.all(missing.map((file) => loadScript(base + file.path)))
  const failed = missing.some((file, index) => file.required && (!arrived[index] || !window[file.global]))
  if (failed) return null

  return {
    manifest: window.MAP_MANIFEST,
    atlas: window.MARKER_ATLAS,
    cities: window.MAP_CITIES || [],
    deep: window.DeepRenderer && typeof window.DeepRenderer.renderTile === "function" ? window.DeepRenderer : null
  }
}
